var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopifyAppsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f99b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34256,
    stopColor: "#9fc85d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#7cb342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558b2f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.30139,39.33392c-.43433-2.05713-2.25409-9.07733-7.16486-10.91669-1.80579-.67664-2.99512-.18433-3.67462.34711-.15723.12305-.29932.26672-.43555.4176-1.60461-.58374-2.66925-.14398-3.2807.33527-1.25879.98523-1.7395,3.01636-1.8949,4.9165l-1.63568-.48724,2.07764,37.64087,22.89685-4.28992-3.25769-26.88208-3.63049-1.08142ZM49.28497,35.45667l-1.77332-.5282c.1062-1.76166.46637-3.44922,1.27539-4.08209.13214-.10376.50549-.39264,1.33868-.17975-.59283,1.42841-.79932,3.21997-.84076,4.79004ZM50.96857,35.95813c.01727-1.62604.20319-3.32953.66833-4.53711,1.86371,1.34802,2.99371,3.90045,3.60712,5.81073l-4.27545-1.27362ZM57.17743,37.80768c-.56531-2.12012-1.90253-5.85364-4.58582-7.77972.24811-.17365.81683-.45447,1.95294-.0293,3.54999,1.32965,5.24976,6.31396,5.88733,8.77832l-3.25446-.9693Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "39.05963 35.94666 35.435 35.94666 30.81042 69.03735 43.06305 71.91211 40.93823 33.41602 39.05963 35.94666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopifyAppsScraper);
export default __webpack_public_path__ + "static/media/shopify-apps-scraper.e0b7fc15d66ab5713cae984fcc983c74.svg";
export { ForwardRef as ReactComponent };